import { Effect, Layer } from "effect";
import { BrowserHttpClient } from "@effect/platform-browser";
import { withWorkerstationBase } from "@workerstation/shared";
import { KVApi } from "../../api/kv/service.ts";
import { makeKVApi } from "../../api/kv/live.ts";

export const KVBrowserPortsLive = Layer.effect(KVApi, Effect.gen(function* () {
  const base = yield* Effect.sync(() => (typeof window === "undefined" ? "https://workerstation.invalid" : window.location.origin) + withWorkerstationBase(""));
  return yield* makeKVApi(base);
})).pipe(Layer.provide(BrowserHttpClient.layerFetch));
